import { render } from "./ProjectsDelete.vue?vue&type=template&id=07245b12"
import script from "./ProjectsDelete.vue?vue&type=script&lang=js"
export * from "./ProjectsDelete.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__